import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

import { LoginService } from '../services/login.service';

@Injectable()
export class AuthorizationHeaderInterceptor implements HttpInterceptor {

    constructor(private loginService: LoginService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        console.debug('AuthorizationHeaderInterceptor.intercept', request, next);

        let authorization: string | null = request.headers.get('X-MyKronoz-Authorization');

        if (authorization != null) {

            const newHeaders: any = {};
            request.headers.keys().forEach(key => {
                newHeaders[key] = request.headers.getAll(key);
            });
            delete newHeaders['X-MyKronoz-Authorization'];

            let match = null;

            if ((match = authorization.match(/^(?:v[12];)?admin$/)) != null) {

                let handleRequest = (token: string | null, request: HttpRequest<any>) => {
                    newHeaders['Authorization'] = `Bearer ${token}`;
                    request = request.clone({
                        headers: new HttpHeaders(newHeaders)
                    });
                    return next.handle(request).pipe(
                        tap({
                            next: (value: any) => {
                                console.debug('AuthorizationHeaderInterceptor.intercept.tap.value', value);
                            },
                            error: (error: any) => {
                                console.debug('AuthorizationHeaderInterceptor.intercept.tap.error', error);
                                if (error.status == 401) {
                                    this.loginService.sessionExpiredSubject.next(true);
                                }
                            }
                        })
                    );
                };

                if ((match = authorization.match(/^v2;.+$/)) != null) {
                    if (isNaN(this.loginService.lastRefreshTimeV2) || this.loginService.lastRefreshTimeV2 + (6 * 60 * 60 * 1000) < Date.now()) {
                        return this.loginService.requestExtendedRefreshTokenV2(this.loginService.refreshTokenV2).pipe(
                            switchMap((data: any) => {
                                this.loginService.accessTokenV2 = data.access_token;
                                this.loginService.refreshTokenV2 = data.refresh_token;
                                this.loginService.lastRefreshTimeV2 = Date.now();
                                return handleRequest(this.loginService.accessTokenV2, request);
                            }),
                            catchError((error: any) => {
                                if (error.status == 401) {
                                    this.loginService.accessTokenV2 = null;
                                    this.loginService.refreshTokenV2 = null;
                                    this.loginService.lastRefreshTimeV2 = NaN;
                                } else {
                                    this.loginService.lastRefreshTimeV2 = Date.now();
                                }
                                return handleRequest(this.loginService.accessTokenV2, request);
                            })
                        );
                    } else {
                        return handleRequest(this.loginService.accessTokenV2, request);
                    }
                } else {
                    if (isNaN(this.loginService.lastRefreshTimeV1) || this.loginService.lastRefreshTimeV1 + (6 * 60 * 60 * 1000) < Date.now()) {
                        return this.loginService.requestExtendedRefreshTokenV1(this.loginService.refreshTokenV1).pipe(
                            switchMap((data: any) => {
                                this.loginService.accessTokenV1 = data.token;
                                this.loginService.refreshTokenV1 = data.refreshToken;
                                this.loginService.lastRefreshTimeV1 = Date.now();
                                return handleRequest(this.loginService.accessTokenV1, request);
                            }),
                            catchError((error: any) => {
                                if (error.status == 401) {
                                    this.loginService.accessTokenV1 = null;
                                    this.loginService.refreshTokenV1 = null;
                                    this.loginService.lastRefreshTimeV1 = NaN;
                                } else {
                                    this.loginService.lastRefreshTimeV1 = Date.now();
                                }
                                return handleRequest(this.loginService.accessTokenV1, request);
                            })
                        );
                    } else {
                        return handleRequest(this.loginService.accessTokenV1, request);
                    }
                }

            } else if ((match = authorization.match(/^(?:v[12];)?account=(.+)$/)) != null) {

                const accountId: string = match[1];

                if ((match = authorization.match(/^v2;.+$/)) != null) {
                    return this.loginService.getTokenByAccountIdV2(accountId).pipe(
                        switchMap((data: any) => {
                            newHeaders['Authorization'] = `Bearer ${data.access_token}`;
                            request = request.clone({
                                headers: new HttpHeaders(newHeaders)
                            });
                            return next.handle(request);
                        })
                    );
                } else {
                    return this.loginService.getTokenByAccountIdV1(accountId).pipe(
                        switchMap((data: any) => {
                            newHeaders['Authorization'] = `Bearer ${data.token}`;
                            request = request.clone({
                                headers: new HttpHeaders(newHeaders)
                            });
                            return next.handle(request);
                        })
                    );
                }

            } else if ((match = authorization.match(/^(?:v[12];)?email=(.+)$/)) != null) {

                const email: string = match[1];

                if ((match = authorization.match(/^v2;.+$/)) != null) {
                    return this.loginService.getTokenByEmailV2(email).pipe(
                        switchMap((data: any) => {
                            newHeaders['Authorization'] = `Bearer ${data.access_token}`;
                            request = request.clone({
                                headers: new HttpHeaders(newHeaders)
                            });
                            return next.handle(request);
                        })
                    );
                } else {
                    return this.loginService.getTokenByEmailV1(email).pipe(
                        switchMap((data: any) => {
                            newHeaders['Authorization'] = `Bearer ${data.token}`;
                            request = request.clone({
                                headers: new HttpHeaders(newHeaders)
                            });
                            return next.handle(request);
                        })
                    );
                }

            } else {

                request = request.clone({
                    headers: new HttpHeaders(newHeaders)
                });
                return next.handle(request);

            }
        }

        return next.handle(request);
    }
}
